/**
 * @author EdenCha <eden@nurigo.net>
 */
import React from 'react'
import { setPropTypes, setDefaultProps } from 'lib/setPropTypes'
import withStyles from '@material-ui/core/styles/withStyles'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import classNames from 'classnames'

// material UI
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Badge from '@material-ui/core/Badge'
import Popover from '@material-ui/core/Popover'
import Skeleton from '@material-ui/lab/Skeleton'

// material ui icon
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import LockIcon from '@material-ui/icons/Lock'
import HomeIcon from '@material-ui/icons/Home'

// my components
// import UserComponentName from 'components/molecules/UserComponentName'
import PopupContainer from 'containers/PopupContainer'

// libraries
import config from 'config'
import isEqualProps from 'lib/isEqualProps'
import LayoutAccountInfoPopup from 'components/molecules/LayoutAccountInfoPopup'

const styles = theme => ({
  root: {},
  badgeRoot: {
    width: '100%'
  },
  badge: {
    top: 5,
    right: 5
  },
  badgeAnimation: {
    transform: 'translate3d(10px, -10px, 0)',
    animation: `$shake 6s cubic-bezier(.36,.07,.19,.97) infinite`
  },
  '@keyframes shake': {
    '1%, 9%': {
      transform: 'translate3d(9px, -10px, 0)'
    },
    '2%, 8%': {
      transform: 'translate3d(12px, -10px, 0)'
    },
    '3%, 5%, 7%': {
      transform: 'translate3d(6px, -10px, 0)'
    },
    '4%, 6%': {
      transform: 'translate3d(14px, -10px, 0)'
    }
  },
  accountIcon: {
    fontSize: '1.5em',
    marginRight: theme.spacing(1)
  },
  headerLayoutBtn: {
    minWidth: 0,
    whiteSpace: 'nowrap'
  },
  homeIcon: {
    fontSize: '1.1em',
    marginLeft: theme.spacing(1) / 2
  },
  accountNameBtn: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textTransform: 'none'
  },
  popperPapper: {
    width: 600,
    maxWidth: '90%',
    maxHeight: '90vh',
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(2),
    boxShadow: `0 0 15px rgb(0 0 0 / 10%)`
  }
})
export const useProps = {
  testVar: {
    default: '1234',
    type: 'string.isRequired'
  }
}
const LoginMenu = props => {
  const { classes, onClickGotoHomePage, onClickLogin, width } = props
  return (
    <Grid container spacing={1}>
      <Grid item>
        <Button
          fullWidth
          size="small"
          variant="outlined"
          className={classes.headerLayoutBtn}
          onClick={onClickGotoHomePage}
        >
          <HomeIcon size="small" className={classes.accountIcon} />
          {isWidthUp('sm', width) && '홈페이지'}
        </Button>
      </Grid>
      <Grid item>
        <Button
          size="small"
          variant="outlined"
          className={classes.headerLayoutBtn}
          onClick={onClickLogin}
        >
          <LockIcon size="small" className={classes.accountIcon} />
          {isWidthUp('sm', width) && '로그인'}
        </Button>
      </Grid>
      {isWidthUp('sm', width) && (
        <Grid item>
          <Button
            color="primary"
            size="small"
            variant="contained"
            className={classes.headerLayoutBtn}
            href="/oauth2/trial-login"
          >
            무료 체험하기
          </Button>
        </Grid>
      )}
    </Grid>
  )
}
/**
 * (작성된 설명이 없습니다.)
 */
const LayoutHeaderMenu = ({ classes, proxy, ...props }) => {
  const { width, formData = {} } = props
  const {
    anchorRef,
    onChangeFormData,
    onClickQuota,
    onClickCharge,
    onClickProfile,
    onClickNoticeList,
    onClickAccountInfo,
    onClickChangeAccount,
    onClickGotoHomePage,
    onClickLogout,
    onClickLogin,
    onClickConvertTrial,
    onClickCreateExclusiveAccount,
    onClickCopyText,
    onOpenBusinessInfo
  } = proxy
  const popperOpen = formData?.popperOpen
  const auth = formData?.auth
  if (auth === undefined) {
    return (
      <Skeleton
        variant="rect"
        animation="wave"
        width={140}
        style={{ borderRadius: 5 }}
      />
    )
  }
  if (auth === false) {
    return (
      <LoginMenu
        classes={classes}
        auth={auth}
        onClickGotoHomePage={onClickGotoHomePage}
        onClickLogin={onClickLogin}
        width={width}
      />
    )
  }
  const { accountId, targetAccountId, name: accountName, members = [] } = auth
  const me = members.filter(
    memberInfo => memberInfo?.memberId === auth?.memberInfo?.memberId
  )?.[0]
  const nickName = me?.name
  const memberName =
    auth?.memberInfo?.certificate?.name ?? auth?.memberInfo?.name
  // 잔액정보
  const balance = formData?.balance
  const point = formData?.point

  // 알림 목록
  const badgeContent = formData?.badgeContent
  const badgeInvisible = formData?.badgeInvisible
  // 중요 알림 존재 여부
  const isExistImportantNoti = formData?.isExistImportantNoti

  // 후불 여부
  const isDeferredPaymentAccount = formData?.isDeferredPaymentAccount

  // quota
  // const currentQuota = formData?.currentQuota
  const remainingQuota = formData?.remainingQuota

  // 전용계좌
  const hasExclusiveAccount = formData?.hasExclusiveAccount
  const bankAccountNumber = formData?.bankAccountNumber
  const bankName = formData?.bankName

  // 사업자여부
  // const isBusinessAccount = formData?.isBusinessAccount
  const businessName = formData?.businessName
  const businessNumber = formData?.businessNumber
  return (
    <div className={classes.root}>
      <PopupContainer popupKey="layoutHeaderNotification" />
      <Grid
        container
        spacing={1}
        alignItems="center"
        justifyContent="flex-end"
        wrap={config.isCoolsms ? null : 'nowrap'}
      >
        {isWidthUp('sm', width) && auth?.isTrial && (
          <Grid item xs={12}>
            <Button
              color="primary"
              size="small"
              variant="contained"
              fullWidth
              className={classes.headerLayoutBtn}
              href="/trial/convert"
              disableElevation
            >
              실계정으로 전환
            </Button>
          </Grid>
        )}
        <Grid item xs={12}>
          <Badge
            badgeContent={popperOpen ? null : badgeContent}
            invisible={popperOpen || badgeInvisible}
            max={99}
            color="primary"
            classes={
              popperOpen !== true && badgeInvisible === false
                ? {
                    root: classes?.badgeRoot,
                    badge: classNames(classes?.badge, {
                      [classes?.badgeAnimation]: isExistImportantNoti
                    })
                  }
                : {
                    root: classes?.badgeRoot,
                    badge: classes?.badge
                  }
            }
          >
            <Button
              color={targetAccountId ? 'primary' : 'default'}
              size="small"
              variant="outlined"
              fullWidth
              ref={anchorRef}
              className={classes.headerLayoutBtn}
              onClick={() =>
                onChangeFormData({
                  popperOpen: !popperOpen
                })
              }
            >
              <AccountCircleIcon size="small" className={classes.accountIcon} />
              {(config.isCoolsms || isWidthUp('sm', width)) && (
                <>
                  <span className={classes.accountNameBtn}>{accountName}</span>
                  <ArrowDropDownIcon size="small" />
                </>
              )}
            </Button>
          </Badge>
        </Grid>
      </Grid>
      <Popover
        open={popperOpen}
        anchorEl={anchorRef.current}
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        classes={{
          paper: classes.popperPapper
        }}
        onClose={() => {
          onChangeFormData({ popperOpen: false })
        }}
      >
        <LayoutAccountInfoPopup
          isTrial={auth?.isTrial}
          badgeContent={badgeContent}
          badgeInvisible={badgeInvisible}
          isExistImportantNoti={isExistImportantNoti}
          isDeferredPaymentAccount={isDeferredPaymentAccount}
          memberName={memberName}
          nickName={nickName}
          accountId={targetAccountId || accountId}
          accountName={accountName}
          balance={balance}
          point={point}
          todayRemainingQuota={remainingQuota}
          bankName={bankName}
          bankAccountNumber={bankAccountNumber}
          businessName={businessName}
          businessNumber={businessNumber}
          hasExclusiveAccount={hasExclusiveAccount}
          onClickQuota={onClickQuota}
          onClickCharge={onClickCharge}
          onClickProfile={onClickProfile}
          onClickNoticeList={onClickNoticeList}
          onClickAccountInfo={onClickAccountInfo}
          onClickChangeAccount={onClickChangeAccount}
          onClickGotoHomePage={onClickGotoHomePage}
          onClickLogout={onClickLogout}
          onClickLogin={onClickLogin}
          onClickConvertTrial={onClickConvertTrial}
          onClickCreateExclusiveAccount={onClickCreateExclusiveAccount}
          onClickCopyText={onClickCopyText}
          onOpenBusinessInfo={onOpenBusinessInfo}
        />
      </Popover>
    </div>
  )
}

LayoutHeaderMenu.defaultProps = setDefaultProps(useProps)
LayoutHeaderMenu.propTypes = setPropTypes(useProps)
export default React.memo(
  withStyles(styles)(withWidth()(LayoutHeaderMenu)),
  (prevProps, nextProps) => {
    return isEqualProps(nextProps, prevProps, ['width', 'formData'])
  }
)
